import React from "react";
import { Button, Chip } from "@mui/material";
import { SwapHoriz } from "@mui/icons-material";

const SwitchRoleButton = ({ isActive, handleSwitch }) => {
  return isActive ? (
    <Chip label="Active" size="small" color="secondary" variant="filled" />
  ) : (
    <Button
      variant="text"
      sx={{ color: "#757575", fontWeight: 400 }}
      endIcon={<SwapHoriz />}
      onClick={handleSwitch}
    >
      Switch role
    </Button>
  );
};

export default SwitchRoleButton;
